import {
  getFaqsGroups
} from "./chunk-P4HT4TD5.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/faq/groups.ts
import { useQuery } from "@tanstack/react-query";
var useGetFaqsGroups = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getFaqsGroups", props],
    queryFn: () => getFaqsGroups(props)
  }, options));
};

export {
  useGetFaqsGroups
};
//# sourceMappingURL=chunk-IZOMMMXK.mjs.map